import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { ExpandableSearch } from '@components/expandable-search';
import { SearchBox } from '@components/search-box';
import { useIsMobile } from '@hooks/use-is-mobile';

import { Box } from 'components/Box';
import { CreateUserButton } from 'components/CreateUserButton';
import { Header, MobileActions } from 'components/headers';
import { Spacer } from 'components/Spacer';
import { useAuthenticatedUser } from 'features/authentication';
import { useStore } from 'models/Provider';

import { TeamList } from './TeamList';

export const Team = observer(() => {
  const { userStore, t } = useStore();
  const me = useAuthenticatedUser();

  useEffect(() => {
    if (me.role === 'admin' || me.role === 'superadmin') {
      userStore.loadFollowerStats();
    }
  }, [userStore, me.role]);

  return (
    <>
      <Header
        breadcrumbs={<TeamBreadCrumbs />}
        actions={<TeamActions />}
        mobileTitle={t('navigation.settings.team')}
      />

      <TeamList />
    </>
  );
});
export default Team;

const TeamBreadCrumbs = observer(() => {
  const { t } = useStore();
  return <Breadcrumb items={[{ label: t('navigation.settings.team') }]} />;
});

const TeamActions = observer(() => {
  const { uiSettings, t } = useStore();
  const isMobile = useIsMobile();
  const settings = uiSettings.team;

  if (!isMobile) {
    return (
      <TeamActionsContainer>
        <ExpandableSearch
          value={settings.searchStr}
          onChange={settings.setSearchValue}
          onChangeDebounce={0}
          placeholder={t('user.search.tip')}
        />
        <Spacer left={8}>
          <CreateUserButton />
        </Spacer>
      </TeamActionsContainer>
    );
  }
  return (
    <MobileActions>
      <CreateUserButton fullWidth />
      <Box mt="16">
        <SearchBox
          placeholder={t('user.search.tip')}
          value={settings.searchStr}
          onChange={settings.setSearchValue}
          isFullWidth
        />
      </Box>
    </MobileActions>
  );
});

const TeamActionsContainer = styled.div((p) => ({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-end',
}));
